import { IconButton, SlideoutPanel } from "@wayflyer/flyui";
import { IconChevronRight16Line } from "@wayflyer/flyui-icons/16/line";
import { useState } from "react";
import { useIntl } from "react-intl";

import { BaseConnectionPanel, type BaseConnectionPanelProps } from "./base-panel";

export const DefaultManagementPanel = (props: BaseConnectionPanelProps) => {
  const [slideoutOpen, setSlideoutOpen] = useState(false);
  const intl = useIntl();

  const titleMessage = intl.formatMessage({
    id: "shared-ui: manage connection slideout title",
    defaultMessage: "Manage Connection",
  });

  return (
    <SlideoutPanel
      closeOnClickElseWhere={false}
      activator={
        <IconButton
          Icon={IconChevronRight16Line}
          variant="Tertiary"
          onClick={() => setSlideoutOpen(true)}
          accessibilityLabel={titleMessage}
          size="auto"
        />
      }
      open={slideoutOpen}
      onClose={() => setSlideoutOpen(false)}
      title={titleMessage}
    >
      <BaseConnectionPanel {...props} />
    </SlideoutPanel>
  );
};
